import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import useOptions from './useOptions'
import {
  getControlnetPrefineOptions,
  getControlnetPrefineOptionsVariables,
} from '~/graphqls/types'
import { GET_CONTROLNET_PREFINE_OPTIONS } from '~/graphqls/gqls'
import { DEFAULT_OPTIONS, optionsAtom } from './atom'
import { useAtom } from 'jotai'

export const useForm = () => {
  const [, setOptions] = useAtom(optionsAtom)
  const { curSizeOptions } = useOptions()

  const prefineOptionsQuery = useImperativeQuery<
    getControlnetPrefineOptions,
    getControlnetPrefineOptionsVariables
  >(GET_CONTROLNET_PREFINE_OPTIONS)

  /** 场景：照改漫，因为没有尺寸，需要给他计算一个最优的尺寸 */
  const getBestSizeForImage = async (url: string) => {
    if (!url) return Promise.resolve(DEFAULT_OPTIONS.SIZE)

    const p = new Promise<string>(resolve => {
      const img = new Image()
      img.src = url
      img.onload = () => {
        const ratio = img.naturalWidth / img.naturalHeight
        let best: any
        let delta = 10000
        curSizeOptions.map(item => {
          const [w, h] = item.name.split(':')
          const _ratio = Number(w) / Number(h)
          const _delta = Math.abs(_ratio - ratio)
          if (_delta < delta) {
            delta = _delta
            best = item
          }
        })
        resolve(best.name)
      }
    })
    return p
  }

  /** contralet里根据用户上传的图片，获取不同的配置项-主要是价格不同 */
  const setPrefineOptions = ({
    width,
    height,
  }: {
    width: number
    height: number
  }) => {
    prefineOptionsQuery({
      width,
      height,
    }).then(res => {
      setOptions(__options => {
        return {
          ...__options,
          controlPrefineOption:
            res?.data?.pictureGraph?.aiCreateArtworkOptionMenu
              ?.controlPrefineOption,
        } as any
      })
    })
  }

  return {
    getBestSizeForImage,
    setPrefineOptions,
  }
}
